<template>
  <v-main>
    <v-container fluid>
      <v-alert id="alert" v-model="alert.isAlert" :type="alert.type" closable class="row">{{ alert.message }}</v-alert>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="4">
          <v-card class="elevation-12">
            <v-card-title>パスワードの変更</v-card-title>
            <v-card-subtitle></v-card-subtitle>
            <v-card-text>
              <v-form>
                <v-text-field
                  id="currentPassword"
                  v-model="currentPassword"
                  :prepend-icon="mdiLock"
                  placeholder="現在のパスワード"
                  type="password"
                  variant="underlined"
                  @keyup.enter="register"
                ></v-text-field>
                <v-text-field
                  id="newPassword"
                  v-model="newPassword"
                  :prepend-icon="mdiLock"
                  placeholder="新しいパスワード"
                  type="password"
                  variant="underlined"
                  @keyup.enter="register"
                ></v-text-field>
                <v-text-field
                  id="confirmPassword"
                  v-model="confirmPassword"
                  :prepend-icon="mdiLock"
                  placeholder="新しいパスワード(確認用)"
                  type="password"
                  variant="underlined"
                  @keyup.enter="register"
                ></v-text-field>
              </v-form>
            </v-card-text>
            <v-card-actions class="justify-center">
              <v-btn id="cancel" variant="elevated" class="mr-10 mb-10" @click="cancel">キャンセル</v-btn>
              <v-btn id="register" variant="elevated" class="ml-10 mb-10" color="primary" :disabled="isButtonDisabled" @click="register">変更</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import Api from '@/constants/api';
import UserRole from '@/constants/userrole';
import { mdiLock } from '@mdi/js';
import { useAlertStore } from '../stores/alert';

export default {
  setup() {
    const alertState = useAlertStore();
    return {
      alertState,
    };
  },
  data: () => ({
    userId: '',
    userEmail: '',
    billinggroupId: '',
    currentPassword: '',
    newPassword: '',
    confirmPassword: '',
    alert: {
      isAlert: false,
      type: 'success',
      message: '',
    },
    isButtonDisabled: false,
    loginUser: {
      roleId: -1,
    },
    mdiLock,
  }),
  created: async function () {
    let sessionResponse = await this.axios.get(Api.PATH_SESSION);
    if (sessionResponse.data.status == Api.STATUS_SUCCESS) {
      this.userId = sessionResponse.data.session.mypage_user_id;
      this.userEmail = sessionResponse.data.session.mypage_user_email;
      this.billinggroupId = sessionResponse.data.session.billinggroup_id;
      this.loginUser.roleId = sessionResponse.data.session.role_id;
    } else {
      throw 'API_SESSION failed. status=' + sessionResponse.data.status;
    }
  },

  methods: {
    confirmCurrent: async function () {
      let loginResponse = await this.axios.post(Api.PATH_LOGIN, {
        mypage_user_id: this.userId,
        mypage_user_password: this.currentPassword,
      });
      if (loginResponse.data.status == Api.STATUS_SUCCESS) {
        this.$cookies.set('access_token', loginResponse.data.access_token);
        await this.axios.patch(Api.PATH_SESSION, {
          billinggroup_id: this.billinggroupId,
        });
        return true;
      }
      return false;
    },
    register: async function () {
      this.isButtonDisabled = true;
      try {
        let valmsg = this.validate();
        if (valmsg) {
          this.showAlert('warning', valmsg);
          return;
        }
        let confirmCurrentResult = await this.confirmCurrent();
        if (!confirmCurrentResult) {
          this.showAlert('warning', '現在のパスワードが間違っています。');
          return;
        }
        let passwordResponse = await this.axios.post(Api.PATH_PASSWORD, {
          mypage_user_id: this.userId,
          mypage_user_email: this.userEmail,
          mypage_user_password: this.newPassword,
          mypage_user_current_password: this.currentPassword,
        });
        if (passwordResponse.data.status == Api.STATUS_SUCCESS) {
          if (passwordResponse.data.is_valid) {
            this.alertState.createAlert('success', 'パスワード変更しました。');
            if (this.loginUser.roleId == UserRole.BILLINGUSER) {
              this.$router.push({ name: 'InvoicesList' });
            } else {
              sessionStorage.setItem('is_first_login', true);
              this.$router.push({ name: 'BillingsList' });
            }
          } else {
            this.showAlert('error', 'パスワード変更に失敗しました。');
          }
        } else {
          throw 'API_PASSWORD failed. status=' + passwordResponse.data.status;
        }
      } finally {
        this.currentPassword = '';
        this.newPassword = '';
        this.confirmPassword = '';
        this.isButtonDisabled = false;
      }
    },
    cancel: function () {
      this.$router.back();
    },
    validate: function () {
      let valmsg = '';
      if (!this.currentPassword) {
        valmsg = '現在のパスワードを入力してください。';
        return valmsg;
      }
      if (!this.newPassword) {
        valmsg = '新しいパスワードを入力してください。';
        return valmsg;
      }
      if (!this.confirmPassword) {
        valmsg = '新しいパスワード(確認用)を入力してください。';
        return valmsg;
      }
      if (this.currentPassword == this.newPassword) {
        valmsg = '現在のパスワードと同じパスワードは設定できません。';
        return valmsg;
      }
      if (!/^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z\-@_#]+$/.test(this.newPassword)) {
        valmsg =
          '半角英大文字、半角英小文字、半角数字の3種類を必ず含んでください。記号は「@（アットマーク）」、「_（アンダースコア）」、「-（ハイフン）」、「#（シャープ）」以外は使用できません。';
        return valmsg;
      }
      if (this.newPassword.length < 8 || this.newPassword.length > 25) {
        valmsg = '8文字以上、25文字以下にしてください。';
        return valmsg;
      }
      if (this.newPassword != this.confirmPassword) {
        valmsg = '新しいパスワードと新しいパスワード(確認用)が不一致です。';
        return valmsg;
      }
      return valmsg;
    },
    showAlert: function (type, message) {
      this.alert.isAlert = true;
      this.alert.type = type;
      this.alert.message = message;
    },
  },
};
</script>
